import { render, staticRenderFns } from "./HeaderView2.vue?vue&type=template&id=6326804a&scoped=true"
import script from "./HeaderView2.vue?vue&type=script&lang=js"
export * from "./HeaderView2.vue?vue&type=script&lang=js"
import style0 from "./HeaderView2.vue?vue&type=style&index=0&id=6326804a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326804a",
  null
  
)

export default component.exports